import "normalize.css";
import React from "react";
import { createRoot } from "react-dom/client";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import "./index.scss";
import App from "./App";
import { AudioGenerator } from "./components/AudioGenerator/AudioGenerator";
import { HistoryScreen } from "./components/AudioGenerator/HistoryScreen";
import { Error } from "./components/Error";
import SearchTTS from "./components/SearchTTS";
import LegacyVoiceFinder from "./components/VoiceFinder";
import VoiceFinder from "./components/voices/VoiceFinder";

const container = document.getElementById("root");
if (container !== null) {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        element={<App />}
        errorElement={<Error subject="An error has occurred" />}
      >
        <Route element={<SearchTTS />} path="/" />
        <Route element={<LegacyVoiceFinder />} path="/voices-legacy" />
        <Route element={<VoiceFinder />} path="/voices" />
        <Route element={<AudioGenerator />} path="/generate" />
        <Route element={<HistoryScreen />} path="/generate/history" />
        <Route element={<Error subject="Page not found" />} path="*" />
      </Route>,
    ),
  );
  createRoot(container).render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>,
  );
}
